// Every HUMINT route's path, from its ids (PRD-0032). An id reaches a path from an address — a
// route parameter, `?mark=` — so each is escaped into one segment and the browser's authenticated
// request never walks to another route. Imported by path, not via the barrel.

/** One path segment from an id: escaped, and never `.` or `..`, which the URL parser would walk. */
function pathSegment(id: string): string {
  if (id === '' || id === '.' || id === '..') throw new Error(`Not an id: "${id}"`)
  return encodeURIComponent(id)
}

/**
 * `/v1/cases/{caseId}/humint/{...segments}`, every segment escaped — the case's id too: an id
 * taken from an address stays one segment and never walks to another route.
 */
export function humintPath(caseId: string, ...segments: string[]): string {
  return `/v1/cases/${[caseId, 'humint', ...segments].map(pathSegment).join('/')}`
}
